<template>
  <div class="share-footer has-border-top">
    <a v-if="open_app_url" :href="open_app_url" class="open-app">{{$t('base.openInApp')}}</a>
    <div v-if="permEdit" class="download edit" @click.stop="toggleOnlineedit">
      <i class="iconfont icon-list-edit"></i>
      <p>在线编辑</p>
    </div>
    <div v-if="permDownload" class="download" @click.stop="toggleDownload">
      <i class="iconfont icon-btn-download"></i>
      <p>{{fileType === 'file' ? $t('preview.download') : $t('base.download.folder')}}</p>
    </div>
    <div v-if="permSave" class="save" @click.stop="toggleSave">
      <i class="iconfont icon-save-cloud"></i>
      <p>{{$t('base.save')}}</p>
    </div>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import config from '@/config'

export default {
  name: 'ShareFooter',
  i18n,
  props: {
    permDownload: Boolean,
    permEdit: Boolean,
    permSave: Boolean,
    fileType: String
  },
  data () {
    return {
      open_app_url: config.open_app_url
    }
  },
  methods: {
    toggleSave () {
      this.$emit('toggle-save')
    },
    toggleDownload () {
      this.$emit('toggle-download')
    },
    toggleOnlineedit () {
      this.$emit('toggle-onlineedit')
    }
  }
}
</script>
<style lang="postcss">
.share-footer {
  display: flex;
  box-sizing: border-box;
  min-height: 50px;
  align-items: center;
  background-color: #fff;
  padding: 0 15px;
  z-index: 1;

  & a {
    color: #000
  }

  & i {
    color: #747b93;
  }

  & .open-app {
    flex: 1 1 auto;
    text-align: left;
    color: #000;
    font-size: 16px;
  }

  & .save,
  & .download {
    text-align: center;
    color: #4e5660;

    & p {
      font-size: 12px;
    }
  }

  & .save {
    margin-left: 20px;
  }

  & .edit {
    margin-right: 20px;

    & i {
      font-size: 14px;
    }
  }
}
</style>
